import React from "react";

import OpenCardDetail from "../../../board/components/Kanban/openCardDetail";
import { useGroupingBoardsState } from "../../hooks/useGroupingBoardsState";
import Team from "./Team";
import UsersKanban from "./UsersKanban";

const GroupingBoards = React.memo(() => {
  const { isGroupedByTeam, users, usersFromParams } = useGroupingBoardsState();
  return (
    <div>
      <OpenCardDetail />
      {isGroupedByTeam ? <Team groupingUser={users} /> : <UsersKanban users={usersFromParams} />}
    </div>
  );
});

export default GroupingBoards;
